import React, {useState, useEffect} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear} from '@fortawesome/free-solid-svg-icons';
import {VideoLoader} from '../components/UXHelper';
import { ExtinctionData, ExtinctionVideoData, ApisProvider } from '../components/feactures/dataProvider';
import { LayoutContainer } from './layouts/layout_bi_columns';
import './styles/profile.css';
import { ModalNotify } from '../components/Modals';


export const EndPointDashboard = () => {

  const [endPoint, setEndPoint] = useState({
    selected: '',
    change: false,
  })


  useEffect(() => {
    const endpointURL = window.localStorage.getItem('userEndpoint-extinctionWars');
    setEndPoint((state) => ({
      ...state,
      selected: endpointURL,
    }))
    return () => {

    }
  }, [])
  

  const handleChange = (evt) => {
    const {value} = evt.target;
    setEndPoint((state) => ({
      ...state,
      selected: value,
    }))
  }

  const changeEndPoint = () => {
    window.localStorage.setItem('userEndpoint-extinctionWars', endPoint.selected);
    setEndPoint((state) => ({...state, change: false}))
    window.location.reload(true)
  }

  if(endPoint.change){
    return(
      <div className='endpoint_selected_box'>
        <select className='selector_endpoint' value={endPoint.selected} onChange={handleChange}>
          <option value='https://api.waxsweden.org'>https://api.waxsweden.org</option>
          <option value='https://wax.greymass.com'>https://wax.greymass.com</option>
          <option value='https://wax.pink.gg'>https://wax.pink.gg</option>
          <option value='https://wax.eu.eosamsterdam.net'>https://wax.eu.eosamsterdam.net</option>
          <option value='https://wax.eosusa.news'>https://wax.eosusa.news</option>
          <option value='https://wax-public1.neftyblocks.com'>https://wax-public1.neftyblocks.com</option>
          <option value='https://api-wax-mainnet.wecan.dev'>https://api-wax-mainnet.wecan.dev</option>
          <option value='https://wax.cryptolions.io'>https://wax.cryptolions.io</option>
        </select>
      <div className='btn_change_endpoint'>
        <button className='alt_btn btn_setup' onClick={() => changeEndPoint()}>Change EndPoint</button>
      </div>
    </div>
    )
  }

  return (
    <div className='endpoint_selected_box'>
      <div className='endpoint_url_box'>
        <span>{endPoint.selected}</span>
      </div>
      <div className='btn_change_endpoint'>
        <button className='alt_btn btn_setup' onClick={() => setEndPoint((state) => ({...state, change: true}))}>Edit EndPoint</button>
      </div>
    </div>
  )
}


export const ProfileDashboard = ({userData, showLoader, closerLoader}) => {

  const [assetsData, setAssetsData] = useState({
    hasTicket: false,
    amount: 'No WL Tickets',
    itemsData: [],
  })

  const [nofity, setNotify] = useState({
    status: false,
    error: false,
    title: '',
    msg: '',
    txId: '',
  })

  const [refreshComp, setRefreshComp] = useState('')
  const [loadingData, setloadingData] = useState(false);
  const [uInterface, setUInterface] = useState({
    setup: false,
  })
  

  useEffect(() => {
    if(userData.isConnected){

      loadAccountData()
    }
  
    return () => {
      

    }
  }, [userData.isConnected])

  useEffect(() => {
    loadAccountData()
  
    return () => {
      
    }
  }, [refreshComp])

  const loadAccountData = async() => {
    setloadingData(true)
    setAssetsData({
      hasTicket: false,
      amount: 'No WL Tickets',
      itemsData: [],
    })

    const api = `${ApisProvider.atomicApi}atomicassets/v1/accounts?match_owner=${userData.username}&template_id=${ExtinctionData.ID_TICKETS_WL}&page=1&limit=100&order=desc`;

    const response = await fetch(api, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
        }
    });
    const data = await response.json();
    const assetData = data.data;

    if(Number(assetData.length) > 0){
      const data = assetData[0];

      const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${ExtinctionData.collectionName}&schema_name=exwr.tickets&owner=${userData.username}&page=1&limit=${data.assets}&order=desc&sort=asset_id`;

    const response = await fetch(api, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
        }
    });
    const data2 = await response.json();
    const assetData2 = data2.data;

      setAssetsData({
        hasTicket: true,
        amount: data.assets,
        itemsData: assetData2,
      })
      setTimeout(setloadingData, 1000, false);

    }
    else{
      setAssetsData({
        hasTicket: false,
        amount: 'No WL Tickets',
      })
      setTimeout(setloadingData, 1000, false);
    }
  }

  const claimTicket = async(id) => {
    if(userData.whichProvider === 'Anchor'){
      if(Number(id) === 1){
        try{
          const action = {
            account: 'atomicassets',
            name: 'transfer',
            authorization: [userData.auths],
            data: {
              from: userData.username,
              to: ExtinctionData.EXTINCTION_CONTRACT,
              asset_ids: [assetsData.itemsData[0].asset_id],
              memo: 'Option 1',
            },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);
            setloadingData(true);
            setTimeout(() => {
              setRefreshComp(transaction.id.toString());
            }, 1000);
          })
        }catch(err){
          
        }
      }
      else if(Number(id) === 2){
        try{
          const action = {
            account: 'atomicassets',
            name: 'transfer',
            authorization: [userData.auths],
            data: {
              from: userData.username,
              to: ExtinctionData.EXTINCTION_CONTRACT,
              asset_ids: [assetsData.itemsData[0].asset_id],
              memo: 'Option 2',
            },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);
          setloadingData(true);
          setTimeout(() => {
            setRefreshComp(transaction.id.toString());
          }, 1000);
          })
        }catch(err){
          
        }
      }
    }
    else if(userData.whichProvider === 'WaxCloud'){
      if(Number(id) === 1){
        try{
          const action = {
              actions: [{
                  account: 'atomicassets',
                  name: 'transfer',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                      from: userData.username,
                      to: ExtinctionData.EXTINCTION_CONTRACT,
                      asset_ids: [assetsData.itemsData[0].asset_id],
                      memo: 'Option 1',
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
            setloadingData(true);
            setTimeout(() => {
              setRefreshComp(transaction.transaction_id);
            }, 1000);
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
        }
      }
      else if(Number(id) === 2){
        try{
          const action = {
              actions: [{
                  account: 'atomicassets',
                  name: 'transfer',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                      from: userData.username,
                      to: ExtinctionData.EXTINCTION_CONTRACT,
                      asset_ids: [assetsData.itemsData[0].asset_id],
                      memo: 'Option 2',
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
            setloadingData(true);
            setTimeout(() => {
              setRefreshComp(transaction.transaction_id);
            }, 1000);
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
        }
      }
      
    }  
  }
  
  if(!userData.isConnected){
    return (
        <div className='signIn_box'>
            <h2 className='signIn-letter'>You need to sign in before!</h2>
        </div>
    )
  }

  if(showLoader){
    return (
      <div className='loader_animation'>
        <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
      </div>
    )
  }

  if(loadingData){
    return (
        <div className='loading-box'>
            <div className="spinner-border">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
  }

  if(uInterface.setup){
    return(
      <LayoutContainer styles_element={{backgroundColor: '#161617'}}>
        <div className='header_container_profile'>
        <button className='btn_setup_account' onClick={() => setUInterface({setup: false})}>Back</button>
        </div>
        <div className='profile_setup_main_container'>
        {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
              setNotify({
                  status: false,
                  error: false,
                  title: '',
                  msg: '',
                  txId: '',
              })
        }}/>}
          <div className='endpoint_setup_container'>
              <EndPointDashboard />
          </div>
        </div>
      </LayoutContainer>
    )
  }

  if(assetsData.hasTicket){
    return(
      <LayoutContainer styles_element={{backgroundColor: '#161617'}}>
        <div className='header_container_profile'>
          <button className='btn_setup_account' onClick={() => setUInterface({setup: true})}><FontAwesomeIcon icon={faGear}/></button>
        </div>
        <div className='profile_main_container'>
        {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
              setNotify({
                  status: false,
                  error: false,
                  title: '',
                  msg: '',
                  txId: '',
              })
            }}/>}
          <div className='stand_structer_blackm'>
            <div className='preview_item_stand_container_blackm'>
              <span className='title_item_stand_blackm'></span>
              <img src={'https://extinctionwars.com/assets/img/app-resources/ticket_exchange.png'} alt={'WL'} className='img_item_stand'/>
              <span className='difuser_visual_item_stand_blackm'></span>
              <span className='caption_item_stand_blackm'>WL ticket claim</span>
            </div>
            <div className='footer_and_cta_container_stand_blackm'>
              <div className='cta_btns_box'>
                <button className='cta_wl_claim' onClick={()  => claimTicket(1)}>Train Kit</button>
                <button className='cta_wl_claim' onClick={()  => claimTicket(2)}>Legend. Box</button>
              </div>
              <div className='amount_tickets_claim'>
                <span>Tickets owned: {assetsData.amount}</span>
              </div>
            </div>
          </div>
        </div>
      </LayoutContainer>
    )
  }

  return (
        <LayoutContainer>
          <div className='header_container_profile'>
            <button className='btn_setup_account' onClick={() => setUInterface({setup: true})}><FontAwesomeIcon icon={faGear}/></button>
          </div>
            <div className='profile_main_container'>
              <div>
                <h1>{assetsData.amount}</h1>
              </div>
            </div>
        </LayoutContainer>
  )
}
